import React from 'react'
import useStyles from './styles'

interface ColourIndicatorProps {
  colour: string
  add?: boolean
}
const ColourIndicator: React.FC<ColourIndicatorProps> = ({ colour, add }) => {
  const classes = useStyles({ colour, add })

  return (
    <div
      className={classes.dot}
      style={{
        backgroundColor: colour
          ? add
            ? `${colour}`
            : `#${colour}`
          : '#FFFFFF',
        marginRight: '0.5rem',
        border: colour?.toLowerCase() === '#ffffff' ? '1px solid black' : null,
        flexShrink: 0
      }}
    />
  )
}

export default ColourIndicator
